// Generated by purs version 0.15.0
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
var Asap = /* #__PURE__ */ (function () {
    function Asap() {

    };
    Asap.value = new Asap();
    return Asap;
})();
var RequestedTime = /* #__PURE__ */ (function () {
    function RequestedTime(value0) {
        this.value0 = value0;
    };
    RequestedTime.create = function (value0) {
        return new RequestedTime(value0);
    };
    return RequestedTime;
})();
var PreOrder = /* #__PURE__ */ (function () {
    function PreOrder() {

    };
    PreOrder.value = new PreOrder();
    return PreOrder;
})();
var TakeAway = /* #__PURE__ */ (function () {
    function TakeAway() {

    };
    TakeAway.value = new TakeAway();
    return TakeAway;
})();
var Delivery = /* #__PURE__ */ (function () {
    function Delivery() {

    };
    Delivery.value = new Delivery();
    return Delivery;
})();
var DeliveryZone = function (x) {
    return x;
};
var AutoAssign = /* #__PURE__ */ (function () {
    function AutoAssign() {

    };
    AutoAssign.value = new AutoAssign();
    return AutoAssign;
})();
var ManualAssign = /* #__PURE__ */ (function () {
    function ManualAssign() {

    };
    ManualAssign.value = new ManualAssign();
    return ManualAssign;
})();
var newtypeDeliveryZone = {
    Coercible0: function () {
        return undefined;
    }
};
var genericRequestedTime = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Asap.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new RequestedTime(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.CartParams (line 35, column 1 - line 35, column 64): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Asap) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof RequestedTime) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.CartParams (line 35, column 1 - line 35, column 64): " + [ x.constructor.name ]);
    }
};
var showRequestedTime = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericRequestedTime)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Asap";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_DateTime.showDateTime))({
        reflectSymbol: function () {
            return "RequestedTime";
        }
    })))
};
var genericOrderType = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return PreOrder.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return TakeAway.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return Delivery.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.CartParams (line 11, column 1 - line 11, column 56): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof PreOrder) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof TakeAway) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Delivery) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.CartParams (line 11, column 1 - line 11, column 56): " + [ x.constructor.name ]);
    }
};
var showOrderType = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericOrderType)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "PreOrder";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "TakeAway";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Delivery";
        }
    }))))
};
var genericDeliveryZone = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showDeliveryZone = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDeliveryZone)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))({
        reflectSymbol: function () {
            return "DeliveryZone";
        }
    }))
};
var genericAssignmentMode = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return AutoAssign.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return ManualAssign.value;
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.CartParams (line 46, column 1 - line 46, column 66): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AutoAssign) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ManualAssign) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Cart.CartParams (line 46, column 1 - line 46, column 66): " + [ x.constructor.name ]);
    }
};
var showAssignmentMode = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericAssignmentMode)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "AutoAssign";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ManualAssign";
        }
    })))
};
var eqRequestedTime = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericRequestedTime)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_DateTime.eqDateTime))))
};
var eqOrderType = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericOrderType)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))))
};
var eqDeliveryZone = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericDeliveryZone)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Data_Eq.eqInt)))
};
var eqAssignmentMode = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericAssignmentMode)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments)))
};
var defaultDeliveryZone = 1;
var defaultAssignmentMode = /* #__PURE__ */ (function () {
    return AutoAssign.value;
})();
export {
    PreOrder,
    TakeAway,
    Delivery,
    DeliveryZone,
    defaultDeliveryZone,
    Asap,
    RequestedTime,
    AutoAssign,
    ManualAssign,
    defaultAssignmentMode,
    genericOrderType,
    showOrderType,
    eqOrderType,
    newtypeDeliveryZone,
    genericDeliveryZone,
    showDeliveryZone,
    eqDeliveryZone,
    genericRequestedTime,
    showRequestedTime,
    eqRequestedTime,
    genericAssignmentMode,
    showAssignmentMode,
    eqAssignmentMode
};
//# sourceMappingURL=index.js.map
